// src/components/admin/TorreDeControl/modals/PostponeModal.jsx
import React, { useState } from 'react';
import { X, Calendar, AlertCircle } from 'lucide-react';
import axios from 'axios';
import DateSelector from '../DateSelector';

const API_URL = process.env.REACT_APP_API_URL;

function PostponeModal({ item, onClose, onUpdate }) {
  const [selectedDate, setSelectedDate] = useState('');
  const [showCalendar, setShowCalendar] = useState(false);
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  function formatDateForDisplay(isoDate) {
    if (!isoDate) return '';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!selectedDate) {
      alert('Por favor selecciona una fecha');
      return;
    }

    setIsLoading(true);

    try {
      const token = localStorage.getItem('token');
      await axios.patch(
        `${API_URL}/api/entrega/postpone/${item.id}`,
        {
          delivery_date: selectedDate,
          postponed_reason: reason.trim() || null,
        },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      alert(`Entrega #${item.id} pospuesta para el ${formatDateForDisplay(selectedDate)}`);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error postponing delivery:', error);
      const errorMsg = error.response?.data?.error || 'Error al posponer entrega';
      alert(errorMsg);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">

        {/* Header */}
        <div className="bg-brand-primary px-6 py-4 flex items-center justify-between rounded-t-lg">
          <h3 className="text-white font-bold text-lg flex items-center gap-2 font-montserrat">
            <Calendar className="w-5 h-5" />
            Posponer Entrega
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">

          {/* Delivery info */}
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 space-y-1">
            <p className="text-sm text-slate-700 font-montserrat">
              <span className="font-semibold">Entrega:</span> #{item.id}
            </p>
            <p className="text-sm text-slate-700 font-montserrat">
              <span className="font-semibold">Destinatario:</span> {item.recipient_name}
            </p>
            {item.district && (
              <p className="text-sm text-slate-700 font-montserrat">
                <span className="font-semibold">Distrito:</span> {item.district}
              </p>
            )}
            <p className="text-sm text-slate-700 font-montserrat">
              <span className="font-semibold">Fecha actual:</span>{' '}
              {item.delivery_date
                ? formatDateForDisplay(item.delivery_date.split('T')[0])
                : 'N/A'}
            </p>
            <p className="text-sm text-slate-700 font-montserrat">
              <span className="font-semibold">Estado:</span> {item.status}
            </p>
          </div>

          {/* New date */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2 font-montserrat">
              Nueva fecha de entrega
            </label>
            <DateSelector
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
              showCalendar={showCalendar}
              onToggleCalendar={() => setShowCalendar(!showCalendar)}
            />
          </div>

          {/* Reason */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2 font-montserrat">
              Motivo de postergación{' '}
              <span className="text-slate-400 font-normal">(opcional)</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Ej: Cliente solicitó cambio de fecha, no había nadie en casa..."
              rows={3}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm font-montserrat text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-primary/40 focus:border-brand-primary resize-none"
            />
          </div>

          {/* Warning note */}
          <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg p-3">
            <AlertCircle className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" />
            <p className="text-xs text-amber-800 font-montserrat">
              Se actualizará la fecha y el estado a <strong>postergado</strong>. La fecha original quedará registrada automáticamente.
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading || !selectedDate}
              className="flex-1 bg-brand-primary hover:bg-brand-primary/90 disabled:bg-slate-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              {isLoading ? 'Posponiendo...' : 'Posponer Entrega'}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default PostponeModal;
